import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=5d9863b4"
import script from "./Dataset.vue?vue&type=script&lang=js"
export * from "./Dataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports